import { ChangeDetectorRef, Directive, Optional, SkipSelf } from "@angular/core";

@Directive({
  selector: 'ntx-base-page'
})
export class BaseComponent<T> {
  // This is a base component that can be extended by other components
  // It contains common functionality that can be reused across different components
  // It is not intended to be used directly
  // It is not intended to be instantiated directly
  // It is not intended to be used as a standalone component
  // It is not intended to be used as a service
  // It is not intended to be used as a directive
  // It is not intended to be used as a pipe


  // constructor(@Optional() @SkipSelf() protected cdRef?: ChangeDetectorRef) { debugger; }


}
